module.exports = __webpack_public_path__ + "img/bread.be5030ca.webp";